/**
 * ⟦C57 · lot 5d · A-174⟧ **Les textes de l'Historique, en deux longueurs.**
 *
 * Le préambule, les listes vides et les deux dialogues de l'abandon disaient trop de choses à la
 * fois. À l'écran : une phrase de 12 mots au plus (la version COURTE). Ce qui s'y lisait avant est
 * gardé mot pour mot (la version LONGUE) et vit derrière « 📰 Les dessous » du panneau. Pur : pas de
 * DOM ; `historique-court.test.ts` mesure les textes courts avec le mètre de l'écran.
 */

/** Le préambule de l'historique du compte. */
export const PREAMBULE_COURT = "Toutes tes chaînes, gardées pour de bon.";
export const PREAMBULE_LONG =
  "Toutes tes chaînes, dans l'ordre où tu les as lancées. Aucune ne disparaît — une chaîne finie devient un mémorial, et un mémorial se relit.";

/** Le préambule de l'historique du bac à sable. */
export const PREAMBULE_BAC_COURT = "Ici, tout vit dans ce navigateur.";
export const PREAMBULE_BAC_LONG =
  "En bac à sable, tout vit dans ce navigateur — il n'y a ni compte, ni serveur, ni classement. Ce qui reste d'une chaîne finie, c'est cette fiche : pas de mémorial, pas de rejeu, juste ce qu'elle a atteint.";

/** Aucune chaîne du tout. */
export const AUCUNE_COURT = "Aucune chaîne pour l'instant.";
export const AUCUNE_LONG =
  "Aucune chaîne pour l'instant. Celle que tu lanceras sera la première ligne de cette page.";

/** Des chaînes en cours, mais aucune de finie. */
export const AUCUNE_FINIE_COURT = "Aucune chaîne finie.";
export const AUCUNE_FINIE_LONG = "Aucune chaîne finie. Tant mieux — mais ça viendra, et elles resteront là.";

/** Le bac à sable sans fiche. */
export const AUCUNE_BAC_COURT = "Aucune chaîne terminée pour l'instant.";
export const AUCUNE_BAC_LONG =
  "Aucune chaîne terminée pour l'instant. La première y laissera sa fiche — même abandonnée.";

/** Le dialogue « Abandonner cette chaîne ? » : le nom, ce qui reste, ce qui ne revient pas. */
export function corpsAbandon(nom: string): string {
  return `« ${nom} » rejoint ton mémorial.\nRien n'est supprimé, mais on ne la rejoue pas.`;
}

/** La même explication, en toutes lettres (version d'avant le chantier) : elle est dans les dessous. */
export const ABANDON_LONG =
  "Une chaîne abandonnée se referme ici et rejoint ton mémorial. Rien n'est supprimé : elle restera dans cette liste, avec sa raison de fin, et tu pourras la relire. Mais on ne revient pas dessus — cette chaîne-là ne se rejoue pas.";

/** Quand le serveur ne confirme pas l'abandon. */
export const ABANDON_ECHEC_TITRE = "Abandon non confirmé";
export const ABANDON_ECHEC_COURT = "Ta chaîne est toujours là : réessaie dans un instant.";
export const ABANDON_ECHEC_LONG =
  "Le serveur n'a pas confirmé l'abandon : ta chaîne est toujours là, au tour exact. Réessaie dans un instant.";
